export const defaultReviewsListItemData = {
  labelNetherlands: '',
  labelFrance: ''
}

export const LangSelectorTemplate = (data) => {
  data = { ...defaultReviewsListItemData, ...data }

  const activeLang = document.documentElement.lang

  if (activeLang === 'nl') {
    return `
    <div class="w-main-menu__action-item--lang-selector__item"><span class=" m-icon m-icon--checkmark-small w-main-menu__action-item--lang-selector__item-icon"></span>${data.labelNetherlands}</div>
    <a class="w-main-menu__action-item--lang-selector__item" href="/fr"><span class="w-main-menu__action-item--lang-selector__item-icon"></span>${data.labelFrance}</a>
   `
  }

  return `
    <div class="w-main-menu__action-item--lang-selector__item"><span class=" m-icon m-icon--checkmark-small w-main-menu__action-item--lang-selector__item-icon"></span>${data.labelFrance}</div>
    <a class="w-main-menu__action-item--lang-selector__item" href="/nl"><span class="w-main-menu__action-item--lang-selector__item-icon"></span>${data.labelNetherlands}</a>
   `
}
